import { makeStyles } from 'tss-react/mui';

const useStylesFieldPhone: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldPhoneFormControl: {
    width: '100%',
  },
  fieldPhone: {
    width: '100%',
    minWidth: '50px !important',
    '& > div': {
      minHeight: 40,
      '& > input': {
        fontSize: 14,
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 7,
        paddingBottom: 7,
      },
    },
  },
  fieldPhoneBordered: {
    '& > div': {
      backgroundColor: theme.palette.background.default,
      border: `1px solid ${theme.palette.info.main}`,
    },
  },
  fieldPhoneOutlined: {
    '& > div': {
      border: '1px solid rgba(0, 0, 0, 0.23)',
      '&.Mui-focused': {
        borderColor: theme.palette.common.black,
        borderWidth: 2,
      },
      '& > input': {
        backgroundColor: theme.palette.background.default,
        paddingLeft: 14,
        paddingRight: 14,
        paddingTop: 15.5,
        paddingBottom: 15.5,
      },
    },
    '& > label[data-shrink="true"]': {
      background: theme.palette.primary.light,
    },
  },
  fieldPhoneNoUnderline: {
    '& > div:before, & > div:after': {
      display: 'none',
    },
  },
}));

export default useStylesFieldPhone;
